import { RestSlice } from '../../../../redux/rest.slice';
import { IppIndustryAttachments } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippAttachmentSlice = new RestSlice<IppIndustryAttachments>(
	localizationService.getLocalizedString('ipp.attachments.pageHeading'),
	Resource.IppIndustryAttachments
);
export default ippAttachmentSlice.rests.reducer;
